const LoanChallenge1ResultsText ="Good Job!  Please review the actual amounts for each loan.  Are you " +
"surprised by the amount of overpayment for the loan that is in the far right column?  When you are done click " +
"the 'Continue' button to finish this challenge."

export default LoanChallenge1ResultsText 
